module.exports = __webpack_public_path__ + "img/hotpot.1c2fa1ef.png";